﻿import {initTooltip} from "./tooltip";
import {expressQuerySelector} from "../common/html";
import {getHtmlRequest} from "../utils_modules/fetch";

export interface IInitShoppingCartDependencies {
	readonly toggleScroll?: () => void;
}

export function initShoppingCart(shoppingCartMenuEl: HTMLElement, itemCountIcon: HTMLElement | null, deps: IInitShoppingCartDependencies) {

	const { toggleScroll } = deps;

	const toggleScrollClass = () => {
		if (toggleScroll) toggleScroll();
	};

	let loaded = false;

	const onCartTooltipOpen = (containerEl: HTMLElement) => {
		const cartContainerEl = expressQuerySelector(containerEl, ".technical-shopping-cart-container", true);
		const cartHasItems = cartContainerEl.getAttribute('data-load') || undefined;
		if (!loaded && (cartHasItems === 'true')) {
			getHtmlRequest("/ajaxxhr/Header/LoadBasket").then(res => {
				cartContainerEl.innerHTML = res;
				if (itemCountIcon && expressQuerySelector(cartContainerEl, '.m-tooltip__empty-cart', false))
					itemCountIcon.remove();
				loaded = true;
			});
		}

		toggleScrollClass();
	};

	return initTooltip(
		{
			buttonEl: shoppingCartMenuEl.previousElementSibling as HTMLElement,
			containerEl: shoppingCartMenuEl,
			onOpen: onCartTooltipOpen,
			onClose: toggleScrollClass,
			iconCloseSelector: ".technical-icon-close",
			openClass: "menu-is-open",
			tooltipSelector: ".o-icon-navigation__shopping-cart-menu",
			toggleIconSelector: ".icon-shopping-basket"
		}
	);
}
